module.exports = __webpack_public_path__ + "img/case_wz.9486bf47.png";